import { NSARouterMakerResult, NSASectionViewTabPageUIProps } from "namirasoft-account-react";
import { IStorageLocal } from "namirasoft-core";
import { EntryRow, UserFullRow } from "namirasoft-password";
import { NamirasoftMap } from "namirasoft-site-map";
import { BaseColumnFormatter, DateTimeFormatter, IDFormatter, StringFormatter, StringFormatterSizeType, URLFormatter } from "namirasoft-site-react";
import { PasswordFormatter } from "./formatters/PasswordFormatter";
import { PasswordRouterProps } from "./PasswordRouterProps";

export class EntryTabPageView
{
    static entry_line_column_prefix = "entry-line-";

    static getTabPage(props: NSARouterMakerResult & PasswordRouterProps & { user: UserFullRow }): NSASectionViewTabPageUIProps<EntryRow>
    {
        return {
            tabs: {
                general: {
                    getColumns: (row: EntryRow) =>
                    {
                        let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);
                        let columns = [
                            BaseColumnFormatter.getColumn(namirasoft.password.tables.entry.columns.id, new IDFormatter(namirasoft, null)),
                            BaseColumnFormatter.getColumn(namirasoft.password.tables.entry.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
                            BaseColumnFormatter.getColumn(namirasoft.password.tables.entry.columns.name, new StringFormatter()),
                            BaseColumnFormatter.getColumn(namirasoft.password.tables.entry.columns.domain, new StringFormatter()),
                        ];
                        let entry_lines = row.entry_line.sort((a, b) => a.order - b.order);
                        for (const line of entry_lines)
                        {
                            let formatter = new PasswordFormatter(props, () => line.sensitive);
                            let col = BaseColumnFormatter.getColumn({
                                table: namirasoft.password.tables.entry,
                                name: EntryTabPageView.entry_line_column_prefix + line.name,
                                text: line.name,
                                type: "String",
                                required: true,
                            }, formatter);
                            columns.push(col);
                        }
                        columns.push(...[
                            BaseColumnFormatter.getColumn(namirasoft.password.tables.entry.columns.host, new StringFormatter()),
                            BaseColumnFormatter.getColumn(namirasoft.password.tables.entry.columns.url, new URLFormatter()),
                            BaseColumnFormatter.getColumn(namirasoft.password.tables.entry.columns.description, new StringFormatter(StringFormatterSizeType.Description)),
                            BaseColumnFormatter.getColumn(namirasoft.password.tables.entry.columns.created_at, new DateTimeFormatter()),
                            BaseColumnFormatter.getColumn(namirasoft.password.tables.entry.columns.updated_at, new DateTimeFormatter()),
                        ]);
                        return columns;
                    },
                    getValue: (row: EntryRow, column: string) =>
                    {
                        if (column.startsWith(EntryTabPageView.entry_line_column_prefix))
                        {
                            let name = column.substring(EntryTabPageView.entry_line_column_prefix.length);
                            let line = row.entry_line.filter(r => r.name === name)[0];
                            if (line)
                                return line.value ?? undefined;
                        }
                        return undefined;
                    }
                }
            }
        }
    }
}